module.exports = __webpack_public_path__ + "static/stars-7f58f1be433374e51848660afb75c2b6.svg";